import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Utils from "../Utils/Utils";

const MainPage = () => {
  const [isReady, setIsReady] = useState(false);
  const [blok, setBlok] = useState<any>({});
  const navigate = useNavigate();
  const location = useLocation();
  const slug =
    window.location.pathname === "/"
      ? "home"
      : window.location.pathname.replace("/", "");
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const scrollToName = params.get("scrollToName");
    const scrollToIndex = params.get("scrollToIndex");
    Utils.getCachedOrStoryblokStory(slug)
      .then((response: any) => {
        const { story, rels } = response;
        const mappedStory = Utils.mapResolvedRelations(story, rels);

        // const page = response?.data?.story;
        setBlok(mappedStory?.content);
        if (!scrollToName && !scrollToIndex) {
          scrollToTop();
        }
        sessionStorage.setItem("published_at", mappedStory?.published_at);
        setIsReady(true);
      })
      .catch((error) => {
        if (error.status === 404) {
          navigate("/404");
        } else if (error.status === 500) {
          navigate("/500");
        }
      });
  }, [location, slug, navigate]);

  useEffect(() => {
    if (!isReady) return;
    const params = new URLSearchParams(window.location.search);
    const scrollToName = params.get("scrollToName");
    const scrollToIndex = params.get("scrollToIndex");
    if (scrollToName && scrollToIndex && !isNaN(Number(scrollToIndex))) {
      setTimeout(() => {
        Utils.scrollTo(scrollToName, Number(scrollToIndex));
      }, 500);
    }
  }, [isReady, location, slug, navigate]);

  useEffect(() => {
    if (process.env.REACT_APP_TRANSCEND_URL) {
      const existingScript = document.getElementById("transcend_script");
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = process.env.REACT_APP_TRANSCEND_URL;
        script.type = "text/javascript";
        script.dataset.cfasync = "false";
        script.dataset.languages = "en,fr-FR,es-ES";
        script.dataset.privacypolicy = "https://privacy.umusic.com/us/";
        script.dataset.localSync = "allow-network-observable";
        script.id = "transcend_script";

        document.head.appendChild(script);
      }
    }
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          {blok?.metatags?.title ||
            "Audiomovers | Audio Software and plugins that never leave your session"}
        </title>
        <meta
          name="description"
          content={
            blok?.metatags?.description ||
            "Audiomovers | Audio Software and plugins that never leave your session"
          }
        />
      </Helmet>
      {blok && (
        <div {...storyblokEditable(blok)}>
          {blok && blok.body
            ? blok.body.map((blokk: any) => {
                return <StoryblokComponent blok={blokk} key={blokk._uid} />;
              })
            : null}
        </div>
      )}
    </div>
  );
};

export default MainPage;
